import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileSignature, Loader2, Save, Scale, Send } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import LitigeFields, { litigePayload, useLitigeOptions } from "./LitigeFields";
import LitigeAvocatDialog from "./LitigeAvocatDialog";
import LitigeProtocol from "./LitigeProtocol";

const err = (e) => e?.response?.data?.detail || "Erreur";

export default function LitigeDetail({ sav, onReload }) {
  const opts = useLitigeOptions();
  const [v, setV] = useState({ ...sav.values, avocat_id: sav.avocat_id });
  const [avocat, setAvocat] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => setV({ ...sav.values, avocat_id: sav.avocat_id }), [sav]);
  const save = async () => {
    setBusy(true);
    try { await api.patch(`/litiges/${sav.id}`, litigePayload(v)); toast.success("Litige enregistré"); onReload(); } catch (e) { toast.error(err(e)); } finally { setBusy(false); }
  };
  const status = async (s) => { try { await api.post(`/litiges/${sav.id}/status`, { status: s }); onReload(); } catch (e) { toast.error(err(e)); } };
  const c = sav.client || {};
  return (
    <div className="space-y-5" data-testid="litige-detail">
      <div className="flex items-end justify-between gap-4">
        <div>
          <div className="text-xs text-norea-textMuted"><Link to="/sav/litiges" className="hover:underline">Litiges</Link> · <Link to={`/dossiers/${sav.dossier_id}`} className="hover:underline" data-testid="litige-dossier-link">Dossier de {[c.prenom, c.nom].filter(Boolean).join(" ")}</Link></div>
          <h1 className="font-heading text-3xl font-medium flex items-center gap-2"><Scale className="w-6 h-6 text-norea-primary" />{sav.reference}</h1>
        </div>
        <select className="input-field w-64 shrink-0" value={sav.status} onChange={(e) => status(e.target.value)} data-testid="litige-status-select">
          {(opts?.statuses || []).map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
        </select>
      </div>
      <div className="text-[11px] text-amber-700" data-testid="litige-provisoire">Statuts, motifs et modèles de protocole provisoires — à valider par Norea.</div>
      <section className="card-flat p-5 space-y-3">
        {!opts ? <Loader2 className="w-4 h-4 animate-spin" /> : <LitigeFields opts={opts} v={v} onChange={setV} />}
        <div className="flex gap-2 justify-end">
          <button onClick={() => setAvocat(true)} className="btn-secondary text-xs inline-flex items-center gap-1.5" data-testid="litige-send-avocat-btn"><Send className="w-3.5 h-3.5" />Transmettre à l'avocat</button>
          <button onClick={save} disabled={busy} className="btn-primary text-xs inline-flex items-center gap-1.5" data-testid="litige-save-btn">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />}Enregistrer</button>
        </div>
        {(sav.avocat_sends || []).length > 0 && <div className="text-xs text-norea-textMuted" data-testid="litige-avocat-sends">
          {sav.avocat_sends.map((s, i) => <div key={i}>Transmis à {s.to} le {new Date(s.at).toLocaleDateString("fr-FR")}{s.simulated ? " (simulation)" : ""}</div>)}</div>}
      </section>
      <section className="card-flat p-5 space-y-3">
        <h3 className="font-heading text-base font-medium inline-flex items-center gap-2"><FileSignature className="w-4 h-4 text-norea-primary" />Protocole d'accord (signature Yousign)</h3>
        <LitigeProtocol sav={sav} opts={opts} onSent={onReload} />
      </section>
      {avocat && <LitigeAvocatDialog sav={sav} onClose={() => setAvocat(false)} onSent={onReload} />}
    </div>
  );
}
